import LinkHref from 'components/LinkHref';
import { Wrapper } from 'components/base';
import { Link } from 'gatsby';
import React from 'react';
import Blog from 'svgs/icons/social-blog.svg';
import Facebook from 'svgs/icons/social-facebook.svg';
import Linkedin from 'svgs/icons/social-linkedin.svg';
import Threads from 'svgs/icons/social-threads.svg';
import YT from 'svgs/icons/social-youtube.svg';
import AWSLogo from 'svgs/logos/aws-logo.svg';
import Logo from 'svgs/logos/logo-company-icon-color.svg';
import SCLogo from 'svgs/logos/sclogo.svg';
import TWMLogo from 'svgs/logos/twm-logo.svg';
import { aws, bInfo, bLinks, col, colItem, copyright, copyrightItem, copyrightWrapper, heading, inner, link, linkForm, logo, partner, root, socialIcons, socialLink, surveycake, twm, wrapper } from './Footer.module.scss';

const Footer = () => {
  const thisYear = new Date().getFullYear();
  return (
    <footer className={root}>
      <Wrapper Tag="nav" aria-labelledby="footer-navigation" size="L" className={wrapper}>
        <div className={bInfo}>
          <Logo className={logo} />
        </div>
        <div className={bLinks}>
          <ul className={col}>
            <li className={colItem}>
              <span className={heading}>產品功能</span>
              <LinkHref text="Email 行銷" link="/features/" className={link} />
              <LinkHref text="簡訊行銷" link="/features/sms-marketing/" className={link} />
              <LinkHref text="一頁式網頁設計工具" link="/features/website-builder/" className={link} />
            </li>
            <li className={colItem}>
              <span className={heading}>加值服務</span>
              <LinkHref
                text="品牌專屬 Email 服務"
                link="/services/domains/"
                className={link}
              />
              <LinkHref
                text="EDM 專人設計"
                link="/services/customized-design/"
                className={link}
              />
              <LinkHref
                text="電子報顧問"
                link="/services/consulting/"
                className={link}
              />
            </li>
            <li className={colItem}>
              <span className={heading}>資源</span>
              <LinkHref
                text="常見問題"
                link="/help-center/"
                className={link}
              />
              <LinkHref
                text="部落格"
                link="https://blog.newsleopard.com/"
                className={link}
              />
              <LinkHref text="API 文件" link="/api/v1/" className={link} openNew={true} />
              <LinkHref
                text="Ebook 下載"
                link="https://events.newsleopard.com/zh-tw/download-ebook/how-to-creat-high-converting-email-marketing"
                className={link}
                openNew={true} 
              />
              <LinkHref
                text="非營利組織優惠方案"
                link="/nonprofit-organization-plan/"
                className={link}
              />
            </li>
            <li className={colItem}>
              <span className={heading}>公司</span>
              <LinkHref
                text="關於電子豹"
                link="/about/"
                className={link}
              />
              <LinkHref
                text="我們的客戶"
                link="/customers/"
                className={link}
              />
              <LinkHref
                text="採購洽詢"
                link="/contact/"
                className={linkForm}
              />
            </li>
            <li>
              <span className={heading}>合作夥伴</span>
              <div className={partner}>
                <div>
                  <a style={{'display': 'block'}} href="https://www.twmsolution.com/cloud/newsleopard/" target="_blank" rel="noopener noreferrer">
                    <TWMLogo className={twm} alt="台灣大哥大" />
                  </a>
                  <Link style={{'display': 'block'}} to="/events/surveycake-referral/" target="_blank" rel="noopener noreferrer"><SCLogo className={surveycake} alt="surveycake" /></Link>
                </div>
                <div>
                  <AWSLogo className={aws} alt="AWS partner" />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </Wrapper>
      <div className={copyright}>
        <Wrapper size="L" className={copyrightWrapper}>
          <div>
            <div className={socialIcons}>
              <a href="https://blog.newsleopard.com/" target="_blank" rel="noopener noreferrer" className={socialLink}><Blog /></a>
              <a href="https://www.facebook.com/newsleopard/" target="_blank" rel="noopener noreferrer" className={socialLink}><Facebook /></a>
              <a href="https://www.linkedin.com/company/newsleopard/" target="_blank" rel="noopener noreferrer" className={socialLink}><Linkedin /></a>
              <a href="https://www.threads.net/@newsleopard_tw" target="_blank" rel="noopener noreferrer" className={socialLink}><Threads /></a>
              <a href="https://www.youtube.com/channel/UC7gaF4ne9In7OgvOtOXZi9A" target="_blank" rel="noopener noreferrer" className={socialLink}><YT /></a>
            </div>
          </div>
          <div className={inner}>
            <div className={copyrightItem}>
              快豹科技有限公司 版權所有 © {thisYear}
            </div>
            <LinkHref
              text="隱私權政策"
              link="/legal/privacy-policy/"
              className={copyrightItem}
            />
            <LinkHref
              text="使用條款"
              link="/legal/terms-of-use/newsleopard/"
              className={copyrightItem}
            />
          </div>
        </Wrapper>
      </div>
    </footer>
  );
};

export default Footer;
